import {MainPage} from "./MainPage.tsx";
import {GlobalPageContainer} from "../components/GlobalPageContainer.tsx";


export const MainPageContainer = () => {
	console.error("Startseite ohne Pfad: Derzeit ist keine Anzeige auf der Startseite geplant")
	return <GlobalPageContainer><MainPage/></GlobalPageContainer>
}
